import axios, { AxiosInstance } from 'axios';

import { IConfig, AXIOS_DEFAULT_CONFIG } from '../common';
import {
  GetComponentsApiResponse,
  GetComponentsByIdUptimeApiResponse,
  GetComponentsByIdUptimeApiArg,
  GetIncidentsApiResponse,
  GetIncidentsUnresolvedApiResponse,
  GetIncidentsByIdApiResponse,
  GetIncidentsByIdApiArg,
  GetStatusApiResponse,
  GetSummaryApiResponse,
  GetUptimeApiResponse,
  GetUptimeApiArg,
} from './types';

export class StatusGateway {
  public api: AxiosInstance;

  constructor(private readonly config: IConfig) {
    this.api = axios.create({
      ...config,
      ...AXIOS_DEFAULT_CONFIG,
      baseURL: config.statusUrl,
    });
  }

  public async getComponents(): Promise<GetComponentsApiResponse> {
    const { data } = await this.api.get<GetComponentsApiResponse>(
      '/api/v1/components',
    );

    return data;
  }

  public async getComponentsByIdUptime({
    id,
    range,
  }: GetComponentsByIdUptimeApiArg): Promise<GetComponentsByIdUptimeApiResponse> {
    const { data } = await this.api.get<GetComponentsByIdUptimeApiResponse>(
      `/api/v1/components/${id}/uptime`,
      {
        params: { range },
      },
    );

    return data;
  }

  public async getIncidents(): Promise<GetIncidentsApiResponse> {
    const { data } = await this.api.get<GetIncidentsApiResponse>(
      '/api/v1/incidents',
    );

    return data;
  }

  public async getIncidentsUnresolved(): Promise<GetIncidentsUnresolvedApiResponse> {
    const { data } = await this.api.get<GetIncidentsUnresolvedApiResponse>(
      '/api/v1/incidents/unresolved',
    );

    return data;
  }

  public async getIncidentsById({
    id,
  }: GetIncidentsByIdApiArg): Promise<GetIncidentsByIdApiResponse> {
    const { data } = await this.api.get<GetIncidentsByIdApiResponse>(
      `/api/v1/incidents/${id}`,
    );

    return data;
  }

  public async getStatus(): Promise<GetStatusApiResponse> {
    const { data } = await this.api.get<GetStatusApiResponse>('/api/v1/status');

    return data;
  }

  public async getSummary(): Promise<GetSummaryApiResponse> {
    const { data } = await this.api.get<GetSummaryApiResponse>(
      '/api/v1/summary',
    );

    return data;
  }

  public async getUptime(
    args?: GetUptimeApiArg,
  ): Promise<GetUptimeApiResponse> {
    const { data } = await this.api.get<GetUptimeApiResponse>(
      '/api/v1/uptime',
      {
        params: { range: args?.range },
      },
    );

    return data;
  }
}
